import React, { useMemo } from "react";
import TabsCustom from "src/components/TabsCustom";

const TabsBar = ({ tabChange, setTabChange }) => {
  const Tabs = {
    all: {
      type: "all",
      name: "Tất cả",
      status: "",
    },
    pending: {
      type: "pending",
      name: "Chờ duyệt",
      status: "0",
    },
    success: {
      type: "success",
      name: "Đã duyệt",
      status: "1",
    },
    reject: {
      type: "reject",
      name: "Từ chối",
      status: "2",
    },
  };

  const items = useMemo(
    () =>
      Object.keys(Tabs).map(key => ({
        key,
        label: <span className="text-tile-tabs">{Tabs[key].name}</span>,
      })),
    []
  );

  return (
    <TabsCustom
      activeKey={tabChange}
      onChange={setTabChange}
      type="card"
      items={items}
    />
  );
};

export default TabsBar;
